import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const InputWrapper = styled.div<{ $invalid: boolean; $filled: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;

  input {
    &:hover,
    &:focus,
    &:active {
      border-color: ${myPalette.blue.main};
      box-shadow: none;
    }

    height: 56px;
    background: ${myPalette.white.main};
    border-width: 1px !important;
    padding: 16px;
    border-radius: 6px;
    color: ${myPalette.midnightBlue.main};
    border-color: ${({ $invalid }) =>
      $invalid
        ? `${myPalette.red.main} !important`
        : myPalette.blue.lightSteelBlue};
  }

  &:focus-within label {
    transform: translateY(-6px) scale(0.75);
    color: ${myPalette.blue.main} !important;
  }

  &:hover label {
    color: ${myPalette.blue.main};
  }

  label {
    ${({ $filled }) =>
      $filled ? 'transform: translateY(-6px) scale(0.75)' : ''};

    color: ${({ $invalid }) =>
      $invalid
        ? `${myPalette.red.main} !important`
        : myPalette.blue.lightSteelBlue};
  }

  ul {
    border-radius: 12px;
    max-height: 200px;
    height: auto;
    overflow: auto;

    button {
      padding: 12px;
      font-size: 16px;
    }
  }
`

export const Label = styled.label`
  position: absolute;
  pointer-events: none;
  transform: translate(0, 19px) scale(1);
  transform-origin: top left;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  color: #6f81a5;
  font-size: 16px;
  left: 13px;
  z-index: 1;
  padding: 0 6px;
  margin-left: -3px;

  &::after {
    content: '';
    width: 100%;
    height: 20px;
    position: absolute;
    display: block;
    background: white;
    top: 6.5px;
    left: 0;
    z-index: -1;
  }
`

export const ErrorMessage = styled.div`
  font-size: 12px;
  color: ${myPalette.red.main};
`
